import { render, staticRenderFns } from "./climbing-height.vue?vue&type=template&id=65444a8d&"
import script from "./climbing-height.vue?vue&type=script&lang=js&"
export * from "./climbing-height.vue?vue&type=script&lang=js&"
import style0 from "./climbing-height.vue?vue&type=style&index=0&id=65444a8d&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports